import { Button, Input } from '@mui/material';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';

import { StyledLabel } from './styles';
import { type ControlledInputFileProps } from './types';

const StyledHiddenInput = styled(Input)`
    display: none;
`;

export const ControlledInputFile = (props: ControlledInputFileProps) => {
    const { control, defaultValue, ...inputProps } = props;

    return (
        <Controller
            name={props.name}
            control={control}
            defaultValue={defaultValue}
            render={({ field }) => (
                <>
                    {props.label && (<StyledLabel>{props.label}</StyledLabel>)}

                    <Button
                        variant="outlined"
                        component="label"
                        disabled={props.disabled}
                        sx={{ width: '10rem' }}
                    >
                        {props.title}
                        <StyledHiddenInput
                            {...field}
                            {...inputProps}
                            type='file'
                            value={undefined}
                            onChange={(e) => {
                                const target = e.target as HTMLInputElement;
                                const { files } = target;

                                if (!files) {
                                    return;
                                }

                                const currentFiles = field.value as File[];
                                const newFiles = Object.values(files);
                                const newAttachments = [...currentFiles];

                                newFiles.forEach((newFile) => {
                                    if (!currentFiles.find((file) => file.name === newFile.name)) {
                                        newAttachments.push(newFile);
                                    }
                                });

                                field.onChange(newAttachments);

                                // Without this, if user removes file, and selects same file again, it would not be selected
                                target.value = '';
                            }}
                        />
                    </Button>
                </>
            )}
        />
    );
};

export default ControlledInputFile;
